import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { PrimeNGConfig } from 'primeng/api';
import Swal from 'sweetalert2';
import { AnnonceService } from '../annonce.service';
import { AgenciesService } from 'app/services/agencies/agencies.service';

@Component({
  selector: 'app-annonce',
  templateUrl: './annonce.component.html',
  styleUrls: ['./annonce.component.scss']
})
export class AnnonceComponent implements OnInit {

  dataSource = new MatTableDataSource();
  displayedColumns: string[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
 
  public announcements: any
  agencies: any;
  p: number = 1;
  
  // State variables
  selectedCity: string = '';
  searchTerm: string = '';          // <-- NEW
  currentPage: number = 1;

  constructor(private agenciesService: AgenciesService, private Announcements: AnnonceService,
    private primengConfig: PrimeNGConfig
  ) { }

  ngOnInit() {
    this.restoreState();
    this.getAnnouncements();
  }

  // ------------------- State persistence -------------------
  saveState() {
    const state = {
      selectedCity: this.selectedCity,
      searchTerm: this.searchTerm,    // <-- NEW
      currentPage: this.p
    };
    localStorage.setItem('annonceState', JSON.stringify(state));
  }

  restoreState() {
    const savedState = localStorage.getItem('annonceState');
    if (savedState) {
      const state = JSON.parse(savedState);
      this.selectedCity = state.selectedCity || '';
      this.searchTerm = state.searchTerm || '';   // <-- NEW
      this.p = state.currentPage || 1;
      this.currentPage = state.currentPage || 1;
    }
  }

  clearState() {
    localStorage.removeItem('annonceState');
  }

  // ------------------- Data loading -------------------
  getAnnouncements() {
    this.Announcements.getAnnouncements().subscribe((data: any) => {
      this.announcements = data;
      console.log("liste des annonces", this.announcements);
      this.applyFilters();     // <-- apply all filters after data arrives
    });
  }

  // ------------------- Combined filtering -------------------
  applyFilters() {
    if (!this.announcements) return;

    // Start with the base filter: exclude commercials
    let filtered = this.announcements.filter((agency: any) => 
      agency.phone_number_commercial !== "yes"
    );

    // City filter
    if (this.selectedCity) {
      filtered = filtered.filter((agency: any) => 
        agency.ville === this.selectedCity
      );
    }

    // Title (search) filter – case‑insensitive
    if (this.searchTerm.trim()) {
      const term = this.searchTerm.trim().toLowerCase();
      filtered = filtered.filter((agency: any) => 
        agency.AnnonceName?.toLowerCase().includes(term)
      );
    }

    this.agencies = filtered;
    console.log("Filtered agencies:", this.agencies);
  }

  // ------------------- City change -------------------
  onCityChange(event: any) {
    this.selectedCity = event.target.value;
    this.p = 1;
    this.currentPage = 1;
    this.applyFilters();
    this.saveState();
  }

  // ------------------- Search change -------------------
  onSearchChange(value: string) {
    this.searchTerm = value;
    this.p = 1;                 // reset to first page
    this.currentPage = 1;
    this.applyFilters();
    this.saveState();
  }

  // ------------------- Pagination change -------------------
  onPageChange(page: number) {
    this.p = page;
    this.currentPage = page;
    this.saveState();
  }

  // ------------------- Delete -------------------
  deleteAgencies(id, i) {
    Swal.fire({
      title: "Êtes-vous sûr(e) ?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le."
    }).then((result) => {
      if (result.isConfirmed) {
        this.Announcements.deleteItem(id).subscribe((response: any) => {
          console.log(response);
          Swal.fire({
            title: "Supprimé!",
            text: "Votre agence a été supprimée.",
            icon: "success"
          });
          // Remove from the local array
          const index = this.agencies.findIndex((a: any) => a._id === id);
          if (index !== -1) this.agencies.splice(index, 1);
          // Also remove from announcements if needed, but re‑filtering is simpler
          // We can refetch or just remove from announcements too
          this.announcements = this.announcements.filter((a: any) => a._id !== id);
          this.saveState();
        });
      }
    });
  }

  // ------------------- Approve -------------------
  approveA(id: string, i: number) {
    this.Announcements.approveAnnouncement(id).subscribe(
      (data: any) => {
        console.log('Approval successful:', data);
        // Update the local status
        const agency = this.agencies.find((a: any) => a._id === id);
        if (agency) agency.isApproved = 'true';
        this.saveState();
      },
      (error) => {
        console.error('Error approving announcement:', error);
      }
    );
  }
}